import { reactive } from "vue";
import { Dataset } from "@/models/dataset";
import L from "leaflet";

export const useGlobalStore = reactive({
    results: [] as Array<Dataset>,
    // Stores bounding box data
    resultsForMap: [] as Array<{ id: number; bbox_xmin: string; bbox_xmax: string; bbox_ymin: string; bbox_ymax: string }>,
    // Stores the geometry of a selection rectangle in the map
    // selectionBox: [] as Array<{ bbox_xmin: string; bbox_xmax: string; bbox_ymin: string; bbox_ymax: string }>,

    // selectionRectangle: null as L.Rectangle | null,
    selectionBox: null as { xmin: number; ymin: number; xmax: number; ymax: number } | null,
    // Stores the geometry of a hovered document in the Map-View-component
    // hoveredBbox: null as { xmin: number; ymin: number; xmax: number; ymax: number } | null,
});